import { render } from "./DeliveryConfirm.vue?vue&type=template&id=0131820c&scoped=true"
import script from "./DeliveryConfirm.vue?vue&type=script&lang=js"
export * from "./DeliveryConfirm.vue?vue&type=script&lang=js"

import "./DeliveryConfirm.vue?vue&type=style&index=0&id=0131820c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0131820c"

export default script